module.exports = "/img/_/_/_/assets/images/creeper/book/rare//6.jpg?6aee015c63c86bd78e42c407add0ae3a";